import { IAuthorListItem } from '@/api/types/blog';
import { useReporting } from '@/hooks/useReporting';
import useRouteInfo from '@/hooks/useRouteInfo';
import { ProviderType } from '@/reporting';
import logger from '@/utils/client-logger';
import { useCallback, useEffect, useRef } from 'react';

export const useBlogAuthorsTrack = () => {
  const { trackEvent } = useReporting();
  const enterTimer = useRef<number>(Date.now());
  const { getFromRouterInfo } = useRouteInfo();
  const pageView = useCallback(() => {
    const { refer_page_name, refer_url_path } = getFromRouterInfo();
    trackEvent(
      {
        eventName: 'BlogAuthorListPage_View',
        properties: {
          refer_page_name,
          refer_url_path,
        },
      },
      [ProviderType.SENSORS],
    );
  }, []);

  const sdBlogAuthorListPageAuthorExp = useCallback((author: IAuthorListItem, index: number) => {
    try {
      const sdEventName = 'BlogAuthorListPageAuthor_Exp';
      trackEvent(
        {
          eventName: sdEventName,
          properties: {
            author_name: author.name,
            author_index: index,
          },
        },
        [ProviderType.SENSORS],
      );
    } catch (e) {
      logger.log(e);
    }
  }, []);

  const sdBlogAuthorListPageAuthorClick = useCallback((author: IAuthorListItem, index: number) => {
    try {
      const sdEventName = 'BlogAuthorListPageAuthor_Click';
      trackEvent(
        {
          eventName: sdEventName,
          properties: {
            author_name: author.name,
            author_index: index,
          },
        },
        [ProviderType.SENSORS],
      );
    } catch (e) {
      logger.log(e);
    }
  }, []);

  useEffect(() => {
    enterTimer.current = Date.now();
    pageView();
  }, []);

  return {
    pageView,
    sdBlogAuthorListPageAuthorExp,
    sdBlogAuthorListPageAuthorClick,
  };
};
